import { useField } from 'formik'
import React from 'react'
import { ComboboxField, ComboboxFieldProps, MultiSelectComboboxField, MultiSelectComboboxFieldProps } from './combobox'

interface ComboboxFieldFormikProps {
    id: string
}

export const ComboboxFieldFormik: React.FC<ComboboxFieldProps & ComboboxFieldFormikProps> = ({ id, ...props }) => {
    const [{ value }, { error }, { setValue }] = useField(id)

    return (
        <ComboboxField
            {...props}
            onChange={setValue}
            value={value}
            id={id}
            error={error}
            status={error ? 'error' : 'normal'}
        />
    )
}

export const MultiSelectComboboxFieldFormik: React.FC<MultiSelectComboboxFieldProps & ComboboxFieldFormikProps> = ({
    id,
    ...props
}) => {
    const [{ value }, { error }, { setValue }] = useField(id)

    return (
        <MultiSelectComboboxField
            {...props}
            onChange={setValue}
            value={value}
            id={id}
            error={error}
            status={error ? 'error' : 'normal'}
        />
    )
}
